var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.file.processed)?_c('div',[_c('vue-sound',{attrs:{"auto-play":false,"show-skip":false,"show-track":false,"file":_vm._f("serverMediaFile")(_vm.file)}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }